import * as React from 'react';
import Linkify from 'linkify-react';

export const renderLink = ({
  attributes,
  content,
}: {
  attributes: { key: string; href: string };
  content: string;
}) => {
  return (
    <a
      key={attributes.key}
      href={attributes.href}
      style={{ color: 'blue', overflowWrap: 'anywhere' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {content}
    </a>
  );
};

type Props = {
  children: React.ReactNode;
};

export const LinkifyLabel = ({ children }: Props) => {
  return <Linkify options={{ render: renderLink as any }}>{children}</Linkify>;
};
